import type { ICategories } from "app/common/services/categoryService.types";
import type {
    IEnrichedIndustries,
    IEnrichedIndustriesRaw,
} from "app/pages/industry-analysis/home/enriched-custom-industries/types";
import { DefaultFetchService } from "app/services/fetchService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { CategoryServiceUtils } from "app/services/CategoryServiceUtils";
import { hasEnrichedCustomIndustryPermission } from "app/pages/industry-analysis/home/enriched-custom-industries/hasEnrichedCustomIndustryPermission";
import { swSettings } from "app/common/services/swSettings";

const ENDPOINT = "api/MarketsOverview/TrafficAndEngagement";
interface IPayloadItem {
    marketId: string;
    countryId: number;
    webSource: string;
}
type IPayload = Array<IPayloadItem>;
export const fetchEnrichedIndustries = (industries: ICategories): Promise<IEnrichedIndustries> => {
    const enrichedIndustriesPromise = new Promise<IEnrichedIndustries>((resolve, reject) => {
        if (!hasEnrichedCustomIndustryPermission() || !industries || industries.length === 0) {
            reject(industries);
            return;
        }
        const fetchService = DefaultFetchService.getInstance();
        const payload: IPayload = industries
            .filter((industry) => !CategoryServiceUtils.hasSegments(industry))
            .map((industry) => {
                const { forApi: marketId } = industry;
                const country = CategoryServiceUtils.getIndustryCountry(industry);
                const { id: countryId } = country;
                const webSource = swSettings.allowedCountry(countryId, "MobileWeb")
                    ? devicesTypes.TOTAL
                    : devicesTypes.DESKTOP;
                return { marketId, countryId, webSource };
            });
        const enrichedIndustriesRaw = fetchService.post<IEnrichedIndustriesRaw>(ENDPOINT, payload);
        enrichedIndustriesRaw
            .then(({ Data: results }) => {
                const enrichedIndustries = industries.map((industry) => {
                    const industryRawData = results.find((result) => result.Id === industry.forApi);
                    if (!industryRawData) {return industry;}
                    const { Visits: visits, PeriodChange: periodChange } = industryRawData;
                    const enrichedIndustry = { ...industry, visits, periodChange };
                    return enrichedIndustry;
                });
                resolve(enrichedIndustries);
            })
            .catch(reject);
    });
    return enrichedIndustriesPromise;
};
